import * as types from './mutation-types'
import { from } from 'rxjs'
import { tap } from 'rxjs/operators'

// 공용으로 사용할 저장소
const state = {
  global: {
    dropdownModeMenu: false,
    dropdownModeBox: false,
    dropdownMode: false
  }
}

// 데이터 읽기만 수행
const getters = {
  globalDropdownModeMenu: state => state.global.dropdownModeMenu,
  globalDropdownModeBox: state => state.global.dropdownModeBox
}

// 컨트롤러 같은 역할
const actions = {
  [types.SET_GLOBAL_DROPDOWNMODEMENU]({ commit }, payload) {
    commit(types.SET_GLOBAL_DROPDOWNMODEMENU, payload)
  },
  [types.SET_GLOBAL_DROPDOWNMODEBOX]({ commit }, payload) {
    commit(types.SET_GLOBAL_DROPDOWNMODEBOX, payload)
  },
  [types.SET_GLOBAL_DROPDOWNMODE](payload) {
    const clearDropdownBox = () => {
      const urbanDropdownElements = window.document.querySelectorAll(
        '.dropdown-box'
      )

      const target = from(urbanDropdownElements).pipe(
        tap(ev => {
          if (ev.classList.length > 1) {
            ev.className = ev.classList[0]
          }
        })
      )
      target.subscribe(() => {
        console.log('Deactivated of all')
      })
    }

    switch (payload) {
      case 'on':
        // console.log('dropdown mode on')
        window.document.addEventListener('click', clearDropdownBox)
        // window.document.addEventListener('click', clearDropdownBox)
        break
      case 'off':
        // console.log('dropdown mode off')
        window.document.removeEventListener('click', clearDropdownBox)
        break
      case 'clear':
        clearDropdownBox()
        break
      default:
      // console.log('default')
    }
  }
}
// 데이터 변형에 대한 부분
const mutations = {
  [types.SET_GLOBAL_DROPDOWNMODEMENU](state, result) {
    console.log(result)
    state.global.dropdownModeMenu = result.active
  },
  [types.SET_GLOBAL_DROPDOWNMODEBOX](state, result) {
    console.log(result)
    state.global.dropdownModeBox = result.active
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
